import { ITableColumn, TableColumnTypeEnum, WidthType } from './tableColumn.interface';

export const PlaybookExecutionTableColumns: ITableColumn[] = [
  {
    labelPath: 'playbooks.playbookName',
    propertyKey: 'playbook',
    colType: TableColumnTypeEnum.Text,
    width: 120,
    widthType: WidthType.Pixel,
    isSortable: false,
  },
  {
    labelPath: 'zenityCommon.integration',
    propertyKey: 'integration',
    colType: TableColumnTypeEnum.Text,
    width: 210,
    widthType: WidthType.Pixel,
    isSortable: false,
  },
  {
    labelPath: 'zenityCommon.policy',
    propertyKey: 'policy',
    colType: TableColumnTypeEnum.Text,
    width: 74,
    widthType: WidthType.Pixel,
    isSortable: false,
  },
  {
    labelPath: 'playbooks.trigger',
    propertyKey: 'trigger',
    colType: TableColumnTypeEnum.Text,
    width: 162,
    widthType: WidthType.Pixel,
    isSortable: false,
  },
  {
    labelPath: 'playbookExecutions.triggeredEntity',
    propertyKey: 'triggeredEntityName',
    linkPropertyKey: 'triggeredEntityUrl',
    colType: TableColumnTypeEnum.LinkNewPage,
    width: 430,
    widthType: WidthType.Pixel,
    isSortable: false,
  },
  {
    labelPath: 'playbookExecutions.resourceName',
    propertyKey: 'resourceName',
    colType: TableColumnTypeEnum.Text,
    width: 200,
    widthType: WidthType.Pixel,
    isSortable: false,
  },
  {
    labelPath: 'zenityCommon.resourceType',
    propertyKey: 'resourceType',
    colType: TableColumnTypeEnum.Text,
    width: 150,
    widthType: WidthType.Pixel,
    isSortable: false,
  },
  {
    labelPath: 'playbookExecutions.environment',
    propertyKey: 'environment',
    colType: TableColumnTypeEnum.Text,
    width: 164,
    widthType: WidthType.Pixel,
    isSortable: false,
  },
  {
    labelPath: 'common.createdBy',
    propertyKey: 'createdBy',
    colType: TableColumnTypeEnum.Avatar,
    width: 300,
    widthType: WidthType.Pixel,
    isSortable: false,
  },
  {
    labelPath: 'common.ownedBy',
    propertyKey: 'ownedBy',
    colType: TableColumnTypeEnum.Avatar,
    width: 500,
    widthType: WidthType.Pixel,
    isSortable: false,
  },
  {
    labelPath: 'playbookExecutions.violationStatus',
    propertyKey: 'violationStatus',
    colType: TableColumnTypeEnum.StatusLabelOrNA,
    width: 140,
    widthType: WidthType.Pixel,
    isSortable: false,
    tooltipDynamicText: 'violationStatusTooltip',
    descriptionLabelPath: 'playbookExecutions.violationStatusDescription',
    hidden: true,
  },
  {
    labelPath: 'playbooks.executionStatus',
    propertyKey: 'status',
    colType: TableColumnTypeEnum.StatusLabel,
    width: 150,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'executionStatus',
  },
  {
    labelPath: 'common.startTime',
    propertyKey: 'startTime',
    colType: TableColumnTypeEnum.DateTime,
    width: 190,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'startTime',
  },
  {
    labelPath: 'common.endTime',
    propertyKey: 'endTime',
    colType: TableColumnTypeEnum.DateTime,
    width: 190,
    widthType: WidthType.Pixel,
    isSortable: true,
    sortKey: 'endTime',
  },
  {
    labelPath: 'playbookExecutions.failedAction',
    propertyKey: 'failedAction',
    colType: TableColumnTypeEnum.TextOrNA,
    width: 130,
    widthType: WidthType.Pixel,
    isSortable: false,
  },
  {
    labelPath: 'playbookExecutions.logs',
    propertyKey: 'viewLogText',
    colType: TableColumnTypeEnum.TextPopup,
    width: 112,
    widthType: WidthType.Pixel,
    isSortable: false,
    textPopupTitleKey: 'viewLogTitle',
    textPopupTextKey: 'logs',
  },
];
